// extracted by mini-css-extract-plugin
export default {"rating":"KH-z","numberOfStars":"LH-z","count":"MH-z","barGraphSpacing":"NH-z","barGraph":"OH-z"};